import { CreateForeignAccountRequest } from "../models/create-foreign-account-request";
import { post } from "./utils";

export const setForeignAccount = async (foreignAccount: CreateForeignAccountRequest) =>
  await post("accounts/foreign", foreignAccount);
